import React from "react";
import { useAuth } from "../../context/AuthContext";
import { getInitials } from "../../utils/helpers";

export default function Topbar({ title, actions }) {
  const { user, logout } = useAuth();

  return (
    <header className="h-16 bg-white border-b border-slate-100 flex items-center justify-between px-6 sticky top-0 z-10">
      <h1 className="font-display font-semibold text-slate-900 text-lg">
        {title}
      </h1>

      <div className="flex items-center gap-4">
        {actions}
        {/* User Avatar + Dropdown */}
        <div className="relative group">
          <button className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <div className="w-9 h-9 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-semibold">
              {getInitials(user?.name || "User")}
            </div>
            <span className="text-sm font-medium text-slate-700 hidden md:block">
              {user?.name}
            </span>
          </button>

          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-44 bg-white border border-slate-100 rounded-xl shadow-lg py-1 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all">
            <div className="px-4 py-2 border-b border-slate-100">
              <p className="text-xs text-slate-500">Signed in as</p>
              <p className="text-sm font-medium text-slate-800 truncate">
                {user?.email}
              </p>
            </div>
            <button
              onClick={logout}
              className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
